import { get, post, postWithParams } from '../utils/request';

// 用户登录相关
// 通过手机号和验证码登录
export const login = (phone, code) => {
  return postWithParams('/core/auth/login/phone', {}, {
    phone,
    code
  });
};

// 获取验证码
export const getVerificationCode = (phone) => {
  return postWithParams('/core/auth/send-code', {}, { phone });
};

// 刷新token
export const refreshTokenApi = (refreshToken) => {
  return post('/core/auth/login/refresh-token', { refreshToken });
};


// 获取用户详情
export const getUserDetail = () => {
  return get('/core/user/detail');
};


// 获取分类列表
export const getCategoryList = (page,tags) => {
  return get('/movie/filter',{
    page,
    tags
  });
};

//详情
export const getDetail = (id) => {
  return get('/movie/detail',{
    id
  });
};

//获取选集播放
export const getEpisodeList = (episodeId,resolution) => {
    return postWithParams('/episode-play-config',{},{
        episodeId,
        resolution
    });
};


//推荐
export const getRecommend = (movieId) => {
    return get('/movie/related',{
      movieId
    });
};

// 创建举报
export const createReport = (data) => {
    return post('/report/create', data);
};

// 获取VIP套餐规则列表
export const getVipRuleList = () => {
    return get('/vip/rule/list');
};

// 获取用户VIP信息
export const getVipRecord = () => {
    return get('/vip/record');
};



